import React from "react";

export function SectionHeader({ eyebrow, title, subtitle, center }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-10 md:mb-14`}>
      {eyebrow && <p className="text-sm font-semibold tracking-widest uppercase text-brand-terracotta mb-3">{eyebrow}</p>}
      <h2 className="font-head text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">{title}</h2>
      {subtitle && <p className="text-base md:text-lg text-slate-600 mt-4 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function Loader({ label = "Loading..." }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-500" data-testid="loader">
      <div className="w-6 h-6 border-2 border-teal border-t-transparent rounded-full animate-spin mr-3" />
      {label}
    </div>
  );
}

export function Empty({ children }) {
  return <div className="text-center py-16 text-slate-500" data-testid="empty-state">{children}</div>;
}

export function fmtDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); }
  catch { return iso; }
}

export function fmtDOB(v) {
  if (!v) return "";
  const s = String(v).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    .toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  return fmtDate(v);
}

export function isBirthdayToday(dob) {
  if (!dob) return false;
  const m = String(dob).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return false;
  const now = new Date();
  let mo = Number(m[2]), day = Number(m[3]);
  // Feb 29 in a non-leap year → celebrate Feb 28
  const yr = now.getFullYear();
  const leap = yr % 4 === 0 && (yr % 100 !== 0 || yr % 400 === 0);
  if (mo === 2 && day === 29 && !leap) day = 28;
  return now.getMonth() + 1 === mo && now.getDate() === day;
}
